// extracted by mini-css-extract-plugin
export default {"inputContent":"myUploadedCV_inputContent__8DwBO","fileName":"myUploadedCV_fileName__Ft8Us","uploadButton":"myUploadedCV_uploadButton__2dyf1"};